module.exports = __webpack_public_path__ + "img/pic-lc.ad706b9b.png";